module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<li class=\"component-point-item-list motion\">\n    <div class=\"column col-1-4\">\n        <div class=\"item-txt\">\n            <strong><$-point $></strong>\n            <p>포인트 이상 (<span><$-num $></span>)</p>\n        </div>\n    </div>\n    <div class=\"column col-3-4 col-full-m\">\n        <div class=\"item-list\">\n            <div class=\"temp\">\n                <$ products.forEach(function(el){ $>\n                <div class=\"column col-1-3 col-half-m\">\n                    <figure>\n                        <img src=\"<$-el.img$>\">\n                    </figure>\n                    <article class=\"txt-holder\">\n                        <span class=\"item-en\"><$-el.sub_title$></span>\n                        <strong class=\"item-ko\"><$-el.title$></strong>\n                    </article>\n                </div>\n                <$ })$>\n            </div>\n        </div>\n    </div>\n    <div class=\"acco-btn\">\n        <button type=\"button\"><span>닫기</span></button>\n    </div>\n</li>\n")
  }
  return __output;

}